<template>
  <div id="search-page">
    <el-tabs v-model="activeName">
      <el-tab-pane v-if="allow_search_types.includes('product')" label="商品" name="product">
        <product-list
          title="相關商品"
          fields="price_range"
          :store-data="storeData"
          :keyword="keyword"
          :search_from="searchFrom"
          hide_pagination
          search_title="搜尋商品"
          :search_path="`搜尋商品 > ${keyword}`"
        ></product-list>
      </el-tab-pane>
      <el-tab-pane v-if="allow_search_types.includes('promotion')" label="促銷" name="promotion">
        <promotion-list
          title="相關促銷"
          fields="banner_media,page,price_range"
          :keyword="keyword"
          :search_from="searchFrom"
          :store-data="storeData"
          hide_pagination
          search_title="搜尋促銷活動"
          :search_path="`搜尋促銷活動 > ${keyword}`"
        ></promotion-list>
      </el-tab-pane>
      <el-tab-pane v-if="allow_search_types.includes('article')" label="文章" name="article">
        <post-list
          title="相關文章"
          :keyword="keyword"
          :search_from="searchFrom"
          search_title="搜尋文章"
          :search_path="`搜尋文章 > ${keyword}`"
          :store_product_id="0"
          :store-data="storeData"
          :limit="12"
        ></post-list>
      </el-tab-pane>

      <el-tab-pane label="保留分頁" name="keepMe" disabled>
        勿刪此隱藏分頁，移除後會導致最後一個文章分頁無法觸發瀑布流下拉偵測
        <product-list
          title="相關商品"
          fields="price_range"
          :keyword="keyword"
          :search_from="searchFrom"
          hide_pagination
          search_title="搜尋商品"
          :search_path="`搜尋商品 > ${keyword}`"
        ></product-list>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script setup>
import { reactive, onMounted, watch, ref } from 'vue'
import { useI18n } from "vue-i18n"
import V3InfiniteLoading from "v3-infinite-loading";
import ProductList from './products/ProductList.vue';
import PromotionList from './promotions/PromotionList.vue';
import PostList from './posts/PostList.vue';

const props = defineProps({
  storeData: Object,
  is_login: { type: Boolean, default: false },
  active_name: { type: String, default: "product" },
  keyword: { type: String, default: "" },
  allow_search_types: { type: Array, default: () => [] },

})

// const activeName = ref("article")
const activeName = ref(props.active_name)
const searchFrom = "search"
</script>

<style lang="scss">
  #search-page .el-tabs__item {
    font-weight: 400;
    font-size: 24px;
  }
  #search-page .el-tabs__item.is-active, #search-page .el-tabs__item:hover {
    /* color: var(--el-color-primary); */
    color: #fe696a;
    background-color: rgba(0, 0, 0, 0);
    border-color: #fe696a;
  }
  #search-page .el-tabs__active-bar {
    /* background-color: var(--el-color-primary); */
    background-color: #fe696a;
  }
  #search-page .el-tabs__nav .is-disabled {
    visibility: hidden;
  }
</style>